import { Colors } from '@prezi/dragon';
export var BaseTheme = {
  buttonColor: Colors.blueLight,
  buttonColorHover: Colors.blue,
  buttonBorderColor: Colors.blueLight,
  buttonTextColor: Colors.white,
  iconFilterColor: 'invert(38%) sepia(70%) saturate(1385%) hue-rotate(200deg) brightness(101%) contrast(107%)',
  CTABorderRadius: '3px'
};